module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/check_circle.3292fa3f.svg";